import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  Delete,
  Filter,
  ReferenceInput,
  SelectInput,
  EditButton,
  BooleanField,
  BooleanInput
} from 'admin-on-rest/lib/mui';

import MapWithASearchBox from '../custom/MapWithASearchBox';

const DestinationFilter = (props) => (
  <Filter {...props}>
    <TextInput label="resources.name.name" source="name" alwaysOn/>
    <ReferenceInput label="resources.companies.name" source="motherCompany" reference="companies" allowEmpty alwaysOn>
    <SelectInput optionText={choice => `${choice.name}`} alwaysOn/>
    </ReferenceInput>
  </Filter>
);

export const SubCompaniesList = (props) => (
  <List {...props}  filters={<DestinationFilter />} title="resources.management_branch.name">
    <Datagrid>
      <TextField source="address" label="resources.branch_address.name" />
      <TextField source="tmima" label="resources.department.name" />
      <BooleanField label="resources.pay_quiz.name" source="quiz_box_paid" />
        <EditButton />
    </Datagrid>
  </List>
);

export const CreateSubCompany = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="tmima" label="resources.department.name" />
        <TextInput source="email" />
        <TextInput source="password" />
        <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty alwaysOn>
        <SelectInput optionText={choice => `${choice.name}`} />
        </ReferenceInput>
        <TextInput source="address" label="resources.address.name" />
        <BooleanInput label="resources.pay_quiz.name" source="quiz_box_paid" />
        <MapWithASearchBox />
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.tmima}` : ''}</span>;
};

export const EditSubCompany = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
      <TextInput source="tmima" label="resources.department.name" />
      <TextInput source="address" label="resources.address.name" />
      <TextInput label="New password" source="newpassword" />
      <TextInput label="Repeat new password" source="repassword" />
      <BooleanInput label="resources.pay_quiz.name" source="quiz_box_paid" />
    </SimpleForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
    return <span>{record ? `Διαγραφή του ${record.title}` : ''}</span>;
};

export const DeleteSubCompany = (props) => <Delete title={<DeleteTitle />} {...props} />;



// WEBPACK FOOTER //
// ./src/pages/companies/sub_companies.js